import { render } from "./VisionMission.vue?vue&type=template&id=2cf39af8&scoped=true"
import script from "./VisionMission.vue?vue&type=script&lang=js"
export * from "./VisionMission.vue?vue&type=script&lang=js"

import "./VisionMission.vue?vue&type=style&index=0&id=2cf39af8&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf39af8"]])

export default __exports__